// extracted by mini-css-extract-plugin
module.exports = {"containerSmall":"DigitalLine_containerSmall__og7jn","circle":"DigitalLine_circle__gi1Lg","column":"DigitalLine_column__21hx5","containerLarge":"DigitalLine_containerLarge__3Dy0t"};